import { Component, input } from '@angular/core';
import { SbSupportTextBlockComponent } from '@app/+modals/sb-support/blocks/text/sb-support-text-block.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AccountModel } from '@reducers/account/account.model';
import { clsx } from 'clsx';

@Component({
  selector: 'sb-support-account-widget',
  templateUrl: './sb-support-account-widget.component.html',
  imports: [SbSupportTextBlockComponent, TranslatePipe],
  host: {
    '[class]': 'hostClass',
  },
})
export class SbSupportAccountWidgetComponent {
  account = input.required<AccountModel>();
  hostClass = clsx('flex flex-col');
}
